import { createAction, props } from '@ngrx/store';
import { ContentGroupFilter } from '../domain/content-group-filter';
import { Feed } from '../domain/feed';
import { Program } from '../domain/program';

const feature = '[CXB Content-group edit screen]';

export const fetchContentGroup = createAction(`${feature} Content-group fetch`, props<{ contentGroupId: number }>());
export const fetchContentGroupSuccess = createAction(`${feature} Content-group fetch success`, props<{ contentGroup: Feed }>());
export const fetchContentGroupFail = createAction(`${feature} Content-group fetch fail`, props<{ errorMessage: string }>());

export const loadCxbContentGroupPreview = createAction(
  `${feature} Content-group preview`,
  props<{ pinnedContentIds: number[]; filter: ContentGroupFilter }>()
);
export const loadCxbContentGroupPreviewSuccess = createAction(`${feature} Content-group preview success`, props<{ programs: Program[] }>());
export const loadCxbContentGroupPreviewFail = createAction(`${feature} Content-group preview fail`, props<{ errorMessage: string }>());

export const searchCxbPrograms = createAction(`${feature} Content-group program search`, props<{ searchTerm: string }>());
export const searchCxbProgramsSuccess = createAction(`${feature} Content-group program search success`, props<{ programs: Program[] }>());
export const searchCxbProgramsFail = createAction(`${feature} Content-group program search fail`, props<{ errorMessage: string }>());

export const setCxbPinnedContentIds = createAction(`${feature} Content-group pinned content ids set`, props<{ contentIds: number[] }>());
export const addCxbPinnedContentId = createAction(`${feature} Content-group pinned content ids add`, props<{ contentId: number }>());
export const deleteCxbPinnedContentId = createAction(`${feature} Content-group pinned content ids delete`, props<{ contentId: number }>());

export const setCxbContentGroupFilter = createAction(`${feature} Content-group filter set`, props<{ filter: ContentGroupFilter }>());

export const setCxbContentGroup = createAction(`${feature} Content-group set`, props<{ contentGroup: Feed }>());

export const setCxbContentGroupIsDynamic = createAction(`${feature} Content-group dynamic set`, props<{ isDynamic: boolean }>());

export const setCxbOriginContentGroupFilter = createAction(
  `${feature} Content-group origin filter set`,
  props<{ filter: ContentGroupFilter }>()
);
export const setCxbOriginContentGroupPinnedContentIds = createAction(
  `${feature} Content-group origin pinned content ids set`,
  props<{ pinnedContentIds: number[] }>()
);

export const updateCxbContentGroupMeta = createAction(
  `${feature} Content-group update meta`,
  props<{ contentGroupId: string; title: string; description: string; isDynamic: boolean }>()
);
export const updateCxbContentGroupMetaSuccess = createAction(
  `${feature} Content-group update meta success`,
  props<{ contentGroup: Feed }>()
);
export const updateCxbContentGroupMetaFail = createAction(`${feature} Content-group update meta fail`, props<{ errorMessage: string }>());

export const updateCxbContentGroup = createAction(`${feature} Content-group update`, props<{ contentGroup: Feed }>());
export const updateCxbContentGroupSuccess = createAction(`${feature} Content-group update success`, props<{ contentGroup: Feed }>());
export const updateCxbContentGroupFail = createAction(`${feature} Content-group update fail`, props<{ errorMessage: string }>());

export const deleteCxbContentGroup = createAction(`${feature} Content-group delete`, props<{ contentGroupId: string }>());
export const deleteCxbContentGroupSuccess = createAction(`${feature} Content-group delete success`);
export const deleteCxbContentGroupFail = createAction(`${feature} Content-group delete fail`, props<{ errorMessage: string }>());
export const resetCxbContentGroupScreenState = createAction(`${feature} Content-group state reset`);
